module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('nav', {
    staticClass: "term-nav"
  }, [_c('div', {
    staticClass: "term-nav__wrap"
  }, [_c('router-link', {
    staticClass: "term-nav__item tag",
    class: {
      'term-nav__item--active': _vm.selectedGroupTermId == null
    },
    attrs: {
      "to": {
        name: 'group.overview'
      }
    }
  }, [_vm._v("Overzicht")]), _vm._l((_vm.terms), function(term, index) {
    return _c('router-link', {
      key: 'term-link-' + term.groupTermId,
      staticClass: "term-nav__item tag",
      class: {
        'term-nav__item--active': _vm.selectedGroupTermId == term.groupTermId, 'term-nav__item--current': _vm.currentGroupTermId == term.groupTermId
      },
      attrs: {
        "to": {
          name: 'students.overview',
          params: {
            groupTermId: term.groupTermId
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(index + 1) + ". " + _vm._s(term.title) + "\n    ")])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5168a620","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/TermNav.vue
// module id = KJNZ
// module chunks = 1